import { v4 as uuidv4 } from "uuid";
import { SubmittedTokenSnapshot } from "@/domain/entities/CreateBookingV3";

export const MAX_SCAN_TOKENS = 100;

export function tokenizeShipmentInput(raw: string): string[] {
  return (raw || "").split(/\s+/).filter((token) => token.length > 0);
}

export function isWithinTokenLimit(tokens: string[]): boolean {
  return tokens.length <= MAX_SCAN_TOKENS;
}

function generateBatchId(): string {
  return uuidv4();
}

export function createSubmittedTokenSnapshot(
  tokens: string[]
): SubmittedTokenSnapshot {
  return Object.freeze(
    new SubmittedTokenSnapshot({
      tokens: Object.freeze([...tokens]) as string[],
      batchId: generateBatchId(),
      submittedAt: new Date().toISOString()
    })
  );
}
